import React from 'react';
import { LoginContainer } from './components/Login.style';
import LoginBackground from './components/LoginBackground';
import LoginModal from './components/LoginModal';
import { Global } from '@emotion/react';

const Login = () => {
  return (
    <LoginContainer data-cy='login-page'>
      <Global
        styles={{
          body: {
            overflow: 'hidden'
          }
        }}
      />
      <LoginModal />
      <LoginBackground />
    </LoginContainer>
  );
};

export default Login;
